import {
  Box,
  Grid,
  List,
  Paper,
  ListItem,
  Container,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check"; // Ícone de check

// Dados para os itens da lista
const whyChooseUsItems = [
  { text: "Consultoria gratuita" },
  { text: "Atendimento pelo WhatsApp" },
  { text: "Melhores operadoras" },
  { text: "Planos empresariais e familiares" },
];

export const WhyChooseUsSection = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: "#F9FAFB",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            mb: 2,
            color: "text.primary",
          }}
        >
          Por que escolher nossos serviços?
        </Typography>
        <Typography
          variant="body1"
          sx={{ textAlign: "center", mb: 6, color: "text.secondary" }}
        >
          Conte com um especialista para encontrar o plano ideal para você e sua
          família
        </Typography>

        {/* Grid com os Itens */}
        <Grid container spacing={3} justifyContent="center">
          {whyChooseUsItems.map((item, index) => (
            <Grid item xs={12} sm={6} md={5} key={index}>
              <Paper
                elevation={0} // Sem sombra, borda sutil
                sx={{
                  p: 2.5,
                  border: "1px solid #E5E7EB", // Borda cinza clara
                  borderRadius: "8px",
                  backgroundColor: "white",
                  height: "100%", // Garante mesma altura se o texto variar
                }}
              >
                <List dense disablePadding>
                  <ListItem disablePadding>
                    <ListItemIcon
                      sx={{
                        minWidth: "auto",
                        mr: 1,
                        color: "#10B981" /* Verde */,
                      }}
                    >
                      <CheckIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      primaryTypographyProps={{
                        sx: { color: "text.secondary" },
                      }}
                    />
                  </ListItem>
                </List>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
